Namespace 'Monitoring.Views.SocialContents.Filters.GoogleMyBusinessFilters'

class Monitoring.Views.SocialContents.Filters.GoogleMyBusinessFilters extends Backbone.View
  template: JST['backbone/templates/monitoring/filters/google_my_business/google_my_business_filters']

  initialize: ({searchQuery}) ->
    @searchQuery = searchQuery
    @ratingsView = new Monitoring.Views.SocialContents.Filters.Ratings({searchQuery: searchQuery})

  render: ->
    @$el.html(@template({title: 'Google My Business'}))
    @$el.find('.ratings').html(@ratingsView.render().el)
    @

  destroy: ->
    @ratingsView.destroy()
    @remove()
